import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'open-link-action',
    templateUrl:'openLinkAction.html'
})
export class OpenLinkActionComponent implements OnInit{

  public linkForm: FormGroup;

  public constructor(public translate: TranslationService,public _appData : AppDataService,private fb : FormBuilder, private _companyService : CompanyService) {
    this.linkForm = this.fb.group({
      linkParam: '',
    });
  }
  public saveData(){
    let linkParam = this.linkForm.controls['linkParam'].value;
    if (!this._appData.action){
      this._appData.action={kind:'openLink',param:{}}
    }
    this._appData.action.param.link=linkParam
    document.getElementById('trigger-action-done').click();
  }
  public reload(){
    let action = this._appData.action;
    if (action.param && action.param.link) {
      this.linkForm = this.fb.group({
        linkParam: action.param.link
      })
    }    
  }
    public ngOnInit(): any {
    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/openLinkAction.ts